import React from 'react';
import { Container } from '../Layout';

const Bottombar = () => {
  return (
    <div>
      <Container className="py-4">
        <p className="text-paragraph-small">
          UGO Care Srl Sede legale: Via Arcivescovo Calabiana 6, 20139 Milano |
          Partita IVA e codice fiscale: IT14634810965
        </p>
      </Container>
    </div>
  );
};

export default Bottombar;
